import {
  FACEBOOK_REPORT_CONTENT_ROWS,
  FACEBOOK_REPORT_PERFORMANCE_ROWS,
} from 'app/modules/analytics/modules/reports/constants/reportMetricRowDefinitions';
import PlatformReportPreviewSections from './PlatformReportPreviewSections';
import type { ReportProfilePreviewSectionsProps } from '../types/ReportProfilePreviewSectionsProps';

const FacebookReportPreviewSections = (
  props: ReportProfilePreviewSectionsProps,
) => (
  <PlatformReportPreviewSections
    {...props}
    config={{
      performanceRows: FACEBOOK_REPORT_PERFORMANCE_ROWS,
      contentRows: FACEBOOK_REPORT_CONTENT_ROWS,
    }}
  />
);

export default FacebookReportPreviewSections;
